import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { AppState } from '@app/reducers';
import { CrudService, debounceTimeForSearchkeyword, IApplicationResponse, ModulesBasedApiSuffix, NO_DATA_FOUND_MESSAGE, prepareGetRequestHttpParams, ResponseMessageTypes, RxjsService, SnackbarService } from '@app/shared';
import { DebtorListSearchModel, SalesModuleApiSuffixModels, selectLeadCreationStepperParamsState$, ServiceAgreementStepsParams } from '@modules/sales';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-debter-list-modal',
  templateUrl: './debter-list-modal.component.html',
  styles: [`.status-dropdown {
    border-radius: 6px;
    width: 75%;
    padding: 0.429em;
  }`]
})
export class DebterListComponent {

  @Output() outputData1 = new EventEmitter<any>();
  selectedDebtor: any;
  activeList = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];
  columnFilterForm!: FormGroup;
  searchColumns: any;
  serviceAgreementStepsParams: any;
  NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;

  constructor(private crudService: CrudService, @Inject(MAT_DIALOG_DATA) public existedDebtors, private snackBarService: SnackbarService,
    private dialog: MatDialog, private rxjsService: RxjsService, private formBuilder: FormBuilder,
    private store: Store<AppState>,) {
    this.store.select(selectLeadCreationStepperParamsState$).subscribe((res: any) => {
      this.serviceAgreementStepsParams = new ServiceAgreementStepsParams(res);
      console.log(this.serviceAgreementStepsParams);
    });
    this.createDebterSearchForm();
  }

  createDebterSearchForm() {
    let debtorSearchModel: any = new DebtorListSearchModel();
    this.columnFilterForm = this.formBuilder.group({});
    Object.keys(debtorSearchModel).forEach((key) => {
      this.columnFilterForm.addControl(key,
        new FormControl(debtorSearchModel[key]));
    });
    if (this.serviceAgreementStepsParams?.leadId) {
      this.columnFilterRequest();
    }
  }

  columnFilterRequest() {
    this.columnFilterForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(obj => {
          Object.keys(obj).forEach(key => {
            if (obj[key] === "") {
              delete obj[key]
            }
          });
          this.searchColumns = Object.entries(obj).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {}) //Filter all falsy values ( null, undefined )

          return of(this.searchDebtor());
        })
      )
      .subscribe();
  }

  searchDebtor() {
    let payload = this.searchColumns;
    if (this.serviceAgreementStepsParams) {
      payload['debtorTypeId'] = this.serviceAgreementStepsParams?.debtorTypeId;
      payload.quotationVersionId = this.serviceAgreementStepsParams.quotationVersionId;
      if (Object.keys(this.serviceAgreementStepsParams?.debtorSearchParams).length > 0) {
        payload = { ...payload, ...this.serviceAgreementStepsParams.debtorSearchParams };
      }
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.SALES_API_SEARCH_DEBTER, undefined, false,
      prepareGetRequestHttpParams(null, null, payload)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          if (response.resources.length == 0) {
            this.existedDebtors = [];
          } else {
            this.existedDebtors = response.resources;
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  search(data) {
    if (data) {
      Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
      data['isLinkDebtor'] = true;
      this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.SALES_API_SEARCH_DEBTER, undefined, false, prepareGetRequestHttpParams(null, null, data), 1).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          if (response.resources.length > 0) {
            this.snackBarService.openSnackbar("No Data Found", ResponseMessageTypes.SUCCESS);
          }
        }
        this.rxjsService.setPopupLoaderProperty(false);
      });
    } else {
      this.snackBarService.openSnackbar("Atleast One search criteria is required", ResponseMessageTypes.WARNING);
    }
  }

  select(i, existedDebtor) {
    this.selectedDebtor = existedDebtor;
    this.existedDebtors.forEach((element, index) => {
      element.isChecked = (index == i) ? true : false;
    });
  }

  linkDebtor() {
    this.dialog.closeAll();
    this.outputData1.emit(this.selectedDebtor);
  }

  skipDebtor() {
    this.dialog.closeAll();
    this.outputData1.emit({ isSkipDebtor: true });
  }

  showSkipButton() {
    return this.existedDebtors?.length ? this.existedDebtors?.every(debtor => debtor?.isDealer) : false;
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
